import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { BecareService } from './services/becare.service';
import { BecareConfigService } from './services/becare-config.service';
import { SNItemFactory } from './models/snitemfactory';
import { SNItem } from './models/snitem';
import { CNItem } from './models/cnitem';
import { SNUser } from './models/snuser';
import { CNPatient } from './models/cnpatient';
import { CNUser } from './models/cnuser';
import { CNHealthAgent } from './models/cnhealthagent';
import { CNDoctor } from './models/cndoctor';
import { CNInsurance } from './models/cninsurance';
import { CNReport } from './models/cnreport';
import { CNReportContent } from './models/cnreportcontent';
import { CNReportDocument } from './models/cnreportdocument';
import { CNReportEcho } from './models/cnreportecho';
import { SNAgendaOpeningHour } from './models/snagendaopeninghour';
import { SNAgendaAppointment } from './models/snagendaappointment';
import { environment } from 'src/environments/environment';
import { TypeManagerService } from './services/type-manager.service';
import { ReportTableComponent } from './components/report/report-table/report-table.component';
import { ReportRowComponent } from './components/report/report-row/report-row.component';
import { AgendaAdminAllDialogComponent } from './dialogs/admin/agenda-admin-all-dialog/agenda-admin-all-dialog.component';
import { ContactRowComponent } from './components/contact/contact-row/contact-row.component';
import { ContactTableComponent } from './components/contact/contact-table/contact-table.component';
import { ContactService } from './services/contact.service';
import { ReportService } from './services/report.service';
import { CNConsultation } from './models/cnconsultation';
import { CNPrescription } from './models/cnprescription';
import { CNPrescriptionEntry } from './models/cnprescriptionentry';
import { PrescriptionEntryComponent } from './components/medication/prescription/prescription-entry/prescription-entry.component';
import { PrescriptionComponent } from './components/medication/prescription/prescription/prescription.component';
import { PrescriptionDialogComponent } from './dialogs/prescription/prescription-dialog/prescription-dialog.component';
import { CNDrug } from './models/cndrug';
import { CNDrugIngredient } from './models/cndrugingredient';
import { CNDrugPackage } from './models/cndrugpackage';
import { CBIPMPP } from 'src/app/models/cbip-mpp';
import { DrugEntryComponent } from './components/medication/drug/drug-entry/drug-entry.component';
import { DrugComponent } from './components/medication/drug/drug/drug.component';
import { PrescriptionEditDialogComponent } from './dialogs/prescription/prescription-edit-dialog/prescription-edit-dialog.component';
import { DrugDialogComponent } from './dialogs/drug/drug-dialog/drug-dialog.component';
import { CNDepartment } from './models/cndepartment';
import { UserDepartmentsAdminDialogComponent } from './dialogs/admin/user-departments-admin-dialog/user-departments-admin-dialog.component';
import { CNContactService } from './models/cncontactservice';
import { CNServiceCode } from './models/cnservicecode';
import { CNServiceCodeINAMI } from './models/cnservicecodeinami';
import { CNServiceCodeINAMIValue } from './models/cnservicecodeinamivalue';
import { DashboardComponent } from './components/dashboard/dashboard/dashboard.component';
import { ContactsPanelComponent } from './components/contact/contacts-panel/contacts-panel.component';
import { RecordPanelComponent } from './components/record/record-panel/record-panel.component';
import { TreatmentService } from './services/treatment.service';
import { CNMedication } from './models/cnmedication';
import { CNHealthProblem } from './models/cnhealthproblem';
import { ProblemService } from './services/problem.service';
import { ProtocolService } from './services/protocol.service';
import { CNProtocol } from './models/cnprotocol';
import { LaboService } from './services/labo.service';
import { CNLabo } from './models/cnlabo';
import { RecordService } from './services/record.service';
import { ContactWidgetComponent } from './components/contact/contact-widget/contact-widget.component';
import { LaboPanelComponent } from './components/labo/labo-panel/labo-panel.component';
import { LaboTableComponent } from './components/labo/labo-table/labo-table.component';
import { MedicationPanelComponent } from './components/medication/medication-panel/medication-panel.component';
import { MedicationTableComponent } from './components/medication/medication-table/medication-table.component';
import { ProblemPanelComponent } from './components/problem/problem-panel/problem-panel.component';
import { ProblemTableComponent } from './components/problem/problem-table/problem-table.component';
import { ProtocolPanelComponent } from './components/protocol/protocol-panel/protocol-panel.component';
import { ProtocolTableComponent } from './components/protocol/protocol-table/protocol-table.component';
import { ItemAccessDialogComponent } from './dialogs/item/item-access-dialog/item-access-dialog.component';
import { UserAdminDialogComponent } from './dialogs/admin/user-admin-dialog/user-admin-dialog.component';
import { UserDomain } from './models/custom/userdomain';
import { PatientCareTeamDialogComponent } from './dialogs/patient/patient-care-team-dialog/patient-care-team-dialog.component';
import { ContactServicesPanelComponent } from './components/service/contact-services-panel/contact-services-panel.component';
import { ServicesService } from './services/services.service';
import { ReportPanelComponent } from './components/report/report-panel/report-panel.component';
import { CNDomain } from './models/cndomain';
import { CNGroup } from './models/cngroup';
import { SNAgenda } from './models/snagenda';
import { ContactEditDialogComponent } from './dialogs/contact/contact-edit-dialog/contact-edit-dialog.component';
import { ContactContentSimpleComponent } from './components/contact/contents/contact-content-simple/contact-content-simple.component';
import { LaboRowComponent } from './components/labo/labo-row/labo-row.component';
import { MedicationRowComponent } from './components/medication/medication-row/medication-row.component';
import { ProblemRowComponent } from './components/problem/problem-row/problem-row.component';
import { ProtocolRowComponent } from './components/protocol/protocol-row/protocol-row.component';
import { ContactComponent } from './components/contact/contact/contact.component';
import { ContactPanelComponent } from './components/contact/contact-panel/contact-panel.component';
import { ContactContentOphtalmoComponent } from './components/contact/contents/contact-content-ophtalmo/contact-content-ophtalmo.component';
import { CNTreatment } from './models/cntreatment';
import { CNTreatmentKine } from './models/cntreatmentkine';
import { CNTreatmentLogo } from './models/cntreatmentlogo';
import { TreatmentDialogComponent } from './dialogs/treatment/treatment-dialog/treatment-dialog.component';
import { CNContactType } from './models/cncontacttype';
import { CNContactTypeGroup } from './models/cncontacttypegroup';
import { CNContactTypeManager } from './models/cncontacttypemanager';
import { CNServiceCodeGroup } from './models/cnservicecodegroup';
import { ContactContentRxComponent } from './components/contact/contents/contact-content-rx/contact-content-rx.component';
import { ContactContentKineComponent } from './components/contact/contents/contact-content-kine/contact-content-kine.component';
import { ContactContentLogoComponent } from './components/contact/contents/contact-content-logo/contact-content-logo.component';
import { CNServiceCodeCustom } from './models/cnservicecodecustom';
import { PrescriptionPanelComponent } from './components/medication/prescription/prescription-panel/prescription-panel.component';
import { SNMessage } from './models/snmessage';
import { SNSMSMessage } from './models/snsmsmessage';
import { ContactUserServicesPanelComponent } from './components/contact/contact-user-services-panel/contact-user-services-panel.component';
import { EHealthDmgListDialogComponent } from './dialogs/e-health/e-health-dmg-list-dialog/e-health-dmg-list-dialog.component';
import { AdminServiceCodeManagementDialogComponent } from './dialogs/admin/admin-service-code-management-dialog/admin-service-code-management-dialog.component';
import { CNDocumentReport } from './models/cndocumentreport';
import { CNDocumentReportContent } from './models/cndocumentreportcontent';
import { CNDocumentReportDocument } from './models/cndocumentreportdocument';
import { ContactContentCardioComponent } from './components/contact/contents/contact-content-cardio/contact-content-cardio.component';
import { CNDisease } from './models/cndisease';
import { CNVaccine } from './models/cnvaccine';
import { CNVaccineSchema } from './models/cnvaccineschema';
import { AdminVaccinationManagementDialogComponent } from './dialogs/admin/admin-vaccination-management-dialog/admin-vaccination-management-dialog.component';
import { SmsConversationDialogComponent } from './dialogs/sms/sms-conversation-dialog/sms-conversation-dialog.component';
import { CNDocumentFile } from './models/cndocumentfile';
import { ContactServicesDialogComponent } from './dialogs/contact/contact-services-dialog/contact-services-dialog.component';
import { SNAgendaDay } from './models/snagendaday';
import { UserService } from './services/user.service';
import { AdminReportValidationDialogComponent } from './dialogs/admin/admin-report-validation-dialog/admin-report-validation-dialog.component';
import { CNContactRXSerie } from './models/cncontactrxserie';
import { CNContactRXImage } from './models/cncontactrximage';
import { CNAnonymousReportRequest } from './models/cnanonymousreportrequest';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Becare9';

  constructor(private becareconfig: BecareConfigService, private factory: SNItemFactory,
              private typemanage: TypeManagerService, private dialog: MatDialog, private services: ServicesService) {
    // Register items
    factory.addItem('SNItem', new SNItem());
    factory.addItem('SNItem.CBIP.MPP', new CBIPMPP());
    factory.addItem('SNItem.CNItem', new CNItem());
    factory.addItem('SNItem.CNItem.CNConsultation', new CNConsultation());
    factory.addItem('SNItem.CNItem.CNContactType', new CNContactType());
    factory.addItem('SNItem.CNItem.CNContactTypeGroup', new CNContactTypeGroup());
    factory.addItem('SNItem.CNItem.CNContactTypeManager', new CNContactTypeManager());
    factory.addItem('SNItem.CNItem.CNContactRXSerie', new CNContactRXSerie());
    factory.addItem('SNItem.CNItem.CNContactRXImage', new CNContactRXImage());
    factory.addItem('stvaast_consultation', new CNConsultation());
    factory.addItem('SNItem.CNItem.CNMedication', new CNMedication());
    factory.addItem('SNItem.CNItem.CNTreatment', new CNTreatment());
    factory.addItem('SNItem.CNItem.CNTreatment.CNTreatmentLogo', new CNTreatmentLogo());
    factory.addItem('SNItem.CNItem.CNTreatment.CNTreatmentKine', new CNTreatmentKine());
    factory.addItem('SNItem.CNItem.CNHealthProblem', new CNHealthProblem());
    factory.addItem('SNItem.CNItem.CNPrescription', new CNPrescription());
    factory.addItem('SNItem.CNItem.CNPrescriptionEntry', new CNPrescriptionEntry());
    factory.addItem('SNItem.CNItem.CNDrug', new CNDrug());
    factory.addItem('SNItem.CNItem.CNDrugIngredient', new CNDrugIngredient());
    factory.addItem('SNItem.CNItem.CNDrugPackage', new CNDrugPackage());
    factory.addItem('SNItem.CNItem.CNDepartment', new CNDepartment());
    factory.addItem('SNItem.CNItem.CNContactService', new CNContactService());
    factory.addItem('SNItem.CNItem.CNServiceCode', new CNServiceCode());
    factory.addItem('SNItem.CNItem.CNServiceCodeGroup', new CNServiceCodeGroup());
    factory.addItem('SNItem.CNItem.CNServiceCode.CNServiceCodeINAMI', new CNServiceCodeINAMI());
    factory.addItem('SNItem.CNItem.CNServiceCode.CNServiceCodeINAMIValue', new CNServiceCodeINAMIValue());
    factory.addItem('SNItem.CNItem.CNServiceCode.CNServiceCodeCustom', new CNServiceCodeCustom());
    factory.addItem('SNItem.CNItem.CNDocumentReport', new CNDocumentReport());
    factory.addItem('SNItem.CNItem.CNDocumentReportContent', new CNDocumentReportContent());
    factory.addItem('SNItem.CNItem.CNDocumentReportDocument', new CNDocumentReportDocument());
    factory.addItem('SNItem.SNDocument.CNDocument.CNDocumentFile', new CNDocumentFile());
    factory.addItem('SNItem.CNItem.CNDisease', new CNDisease());
    factory.addItem('SNItem.CNItem.CNVaccine', new CNVaccine());
    factory.addItem('SNItem.CNItem.CNVaccineSchema', new CNVaccineSchema());
    factory.addItem('SNItem.SNUser', new SNUser());
    factory.addItem('SNItem.SNUser.CNUser', new CNUser());
    factory.addItem('SNItem.SNUser.CNUser.CNGroup', new CNGroup());
    factory.addItem('SNItem.SNUser.CNUser.CNGroup.CNDomain', new CNDomain());
    factory.addItem('SNItem.SNUser.CNUser.CNPatient', new CNPatient());
    factory.addItem('SNItem.SNUser.CNUser.CNHealthAgent', new CNHealthAgent());
    factory.addItem('SNItem.SNUser.CNUser.CNHealthAgent.CNDoctor', new CNDoctor());
    factory.addItem('SNItem.SNUser.CNUser.CNInsurance', new CNInsurance());
    factory.addItem('SNItem.SNAgenda', new SNAgenda());
    factory.addItem('SNItem.SNAgendaDay', new SNAgendaDay());
    factory.addItem('SNItem.SNAgendaOpeningHour', new SNAgendaOpeningHour());
    factory.addItem('SNItem.SNAgendaAppointment', new SNAgendaAppointment());
    factory.addItem('SNItem.SNMessage', new SNMessage());
    factory.addItem('SNItem.SNMessage.SNSMSMessage', new SNSMSMessage());
    factory.addItem('stvaast_rapportconsultation', new CNReport());
    factory.addItem('stvaast_rapportconsultation_contenu', new CNReportContent());
    factory.addItem('stvaast_rapportconsultation_document', new CNReportDocument());
    factory.addItem('stvaast_rapportconsultation_echo', new CNReportEcho());
    factory.addItem('stvaast_protocol', new CNProtocol());
    factory.addItem('stvaast_labo', new CNLabo());
    factory.addItem('userdomain', new UserDomain());
    factory.addItem('SNItem.CNItem.CNAnonymousReportRequest', new CNAnonymousReportRequest());
    // Register types
    this.typemanage.addType('ReportPanelComponent', ReportPanelComponent);
    this.typemanage.addType('ReportTableComponent', ReportTableComponent);
    this.typemanage.addType('ReportRowComponent', ReportRowComponent);
    this.typemanage.addType('ContactTableComponent', ContactTableComponent);
    this.typemanage.addType('ContactsPanelComponent', ContactsPanelComponent);
    this.typemanage.addType('ContactComponent', ContactComponent);
    this.typemanage.addType('ContactPanelComponent', ContactPanelComponent);
    this.typemanage.addType('ContactRowComponent', ContactRowComponent);
    this.typemanage.addType('ContactWidgetComponent', ContactWidgetComponent);
    this.typemanage.addType('PrescriptionEntryComponent', PrescriptionEntryComponent);
    this.typemanage.addType('PrescriptionComponent', PrescriptionComponent);
    this.typemanage.addType('PrescriptionDialogComponent', PrescriptionDialogComponent);
    this.typemanage.addType('PrescriptionEditDialogComponent', PrescriptionEditDialogComponent);
    this.typemanage.addType('PrescriptionPanelComponent', PrescriptionPanelComponent);
    this.typemanage.addType('DrugEntryComponent', DrugEntryComponent);
    this.typemanage.addType('DrugComponent', DrugComponent);
    this.typemanage.addType('DrugDialogComponent', DrugDialogComponent);
    this.typemanage.addType('AgendaAdminAllDialogComponent', AgendaAdminAllDialogComponent);
    this.typemanage.addType('UserDepartmentsAdminDialogComponent', UserDepartmentsAdminDialogComponent);
    this.typemanage.addType('DashboardComponent', DashboardComponent);
    this.typemanage.addType('RecordPanelComponent', RecordPanelComponent);
    this.typemanage.addType('LaboPanelComponent', LaboPanelComponent);
    this.typemanage.addType('LaboTableComponent', LaboTableComponent);
    this.typemanage.addType('MedicationPanelComponent', MedicationPanelComponent);
    this.typemanage.addType('MedicationTableComponent', MedicationTableComponent);
    this.typemanage.addType('ProblemPanelComponent', ProblemPanelComponent);
    this.typemanage.addType('ProblemTableComponent', ProblemTableComponent);
    this.typemanage.addType('ProtocolPanelComponent', ProtocolPanelComponent);
    this.typemanage.addType('ProtocolTableComponent', ProtocolTableComponent);
    this.typemanage.addType('ItemAccessDialogComponent', ItemAccessDialogComponent);
    this.typemanage.addType('UserAdminDialogComponent', UserAdminDialogComponent);
    this.typemanage.addType('PatientCareTeamDialogComponent', PatientCareTeamDialogComponent);
    this.typemanage.addType('ContactServicesPanelComponent', ContactServicesPanelComponent);
    this.typemanage.addType('ContactUserServicesPanelComponent', ContactUserServicesPanelComponent);
    this.typemanage.addType('ContactEditDialogComponent', ContactEditDialogComponent);
    this.typemanage.addType('ContactContentSimpleComponent', ContactContentSimpleComponent);
    this.typemanage.addType('ContactContentOphtalmoComponent', ContactContentOphtalmoComponent);
    this.typemanage.addType('ContactContentRxComponent', ContactContentRxComponent);
    this.typemanage.addType('ContactContentKineComponent', ContactContentKineComponent);
    this.typemanage.addType('ContactContentLogoComponent', ContactContentLogoComponent);
    this.typemanage.addType('ContactContentCardioComponent', ContactContentCardioComponent);
    this.typemanage.addType('ProblemRowComponent', ProblemRowComponent);
    this.typemanage.addType('MedicationRowComponent', MedicationRowComponent);
    this.typemanage.addType('ProtocolRowComponent', ProtocolRowComponent);
    this.typemanage.addType('LaboRowComponent', LaboRowComponent);
    this.typemanage.addType('TreatmentDialogComponent', TreatmentDialogComponent);
    this.typemanage.addType('EHealthDmgListDialogComponent', EHealthDmgListDialogComponent);
    this.typemanage.addType('AdminServiceCodeManagementDialogComponent', AdminServiceCodeManagementDialogComponent);
    this.typemanage.addType('AdminVaccinationManagementDialogComponent', AdminVaccinationManagementDialogComponent);
    this.typemanage.addType('SmsConversationDialogComponent', SmsConversationDialogComponent);
    this.typemanage.addType('ContactServicesDialogComponent', ContactServicesDialogComponent);
    this.typemanage.addType('AdminReportValidationDialogComponent', AdminReportValidationDialogComponent);

    // Instantiate services
    BecareService.getInstance();
    BecareConfigService.getInstance();
    UserService.getInstance();
    ContactService.getInstance();
    ReportService.getInstance();
    TreatmentService.getInstance();
    ProblemService.getInstance();
    ProtocolService.getInstance();
    LaboService.getInstance();
    RecordService.getInstance();
    this.services.loadCodesGroups();
    ServicesService.getInstance();
  }

  ngOnInit(): void {
}

  ngAfterViewInit(): void {
  }
}
